import styled from 'styled-components';

const Tail = styled.p`
  margin: 35px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  > button, > span {
    text-transform: uppercase;
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightHeavy};
    font-size: 16px;
    line-height: 16px;
  }

  > button {
    color: ${props => props.theme.primaryColor};
    border: none;
    border-radius: 4px;
    background: ${props => props.theme.primaryColorTransparent};
    height: 40px;
    width: 350px;
  }

  > span {
    color: ${props => props.theme.secondaryColor};
  }
`;

export default Tail;
